"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_core_1 = require("roosterjs-editor-core");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var roosterjs_editor_api_1 = require("roosterjs-editor-api");
/**
 * TabInTable edit feature, provides the ability to jump between cells when user press TAB in table
 */
exports.TabInTable = {
    keys: [9 /* TAB */],
    shouldHandleEvent: cacheGetTableCell,
    handleEvent: function (event, editor) {
        var shift = event.rawEvent.shiftKey;
        var td = cacheGetTableCell(event, editor);
        for (var vtable = new roosterjs_editor_dom_1.VTable(td), step = shift ? -1 : 1, row = vtable.row, col = vtable.col + step;; col += step) {
            if (col < 0 || col >= vtable.cells[row].length) {
                row += step;
                if (row < 0) {
                    editor.select(vtable.table, -2 /* Before */);
                    break;
                }
                else if (row >= vtable.cells.length) {
                    roosterjs_editor_api_1.editTable(editor, 1 /* InsertBelow */);
                    break;
                }
                col = shift ? vtable.cells[row].length - 1 : 0;
            }
            var cell = vtable.getCell(row, col);
            if (cell.td) {
                editor.select(cell.td, 0 /* Begin */);
                break;
            }
        }
        event.rawEvent.preventDefault();
    },
};
/**
 * UpDownInTable edit feature, provides the ability to jump to cell above/below when user press UP/DOWN
 * in table
 */
exports.UpDownInTable = {
    keys: [38 /* UP */, 40 /* DOWN */],
    shouldHandleEvent: cacheGetTableCell,
    handleEvent: function (event, editor) {
        var td = cacheGetTableCell(event, editor);
        var vtable = new roosterjs_editor_dom_1.VTable(td);
        var isUp = event.rawEvent.which == 38 /* UP */;
        var step = isUp ? -1 : 1;
        var targetTd = null;
        var hasShiftKey = event.rawEvent.shiftKey;
        var _a = editor.getSelection(), anchorNode = _a.anchorNode, anchorOffset = _a.anchorOffset;
        for (var row = vtable.row; row >= 0 && row < vtable.cells.length; row += step) {
            var cell = vtable.getCell(row, vtable.col);
            if (cell.td && cell.td != td) {
                targetTd = cell.td;
                break;
            }
        }
        editor.runAsync(function () {
            var newContainer = editor.getElementAtCursor();
            if (roosterjs_editor_dom_1.contains(vtable.table, newContainer) &&
                !roosterjs_editor_dom_1.contains(td, newContainer, true /*treatSameNodeAsContain*/)) {
                var newPos = targetTd
                    ? new roosterjs_editor_dom_1.Position(targetTd, 0 /* Begin */)
                    : new roosterjs_editor_dom_1.Position(vtable.table, isUp ? -2 /* Before */ : -3 /* After */);
                if (hasShiftKey) {
                    newPos =
                        newPos.node.nodeType == 1 /* Element */ && roosterjs_editor_dom_1.isVoidHtmlElement(newPos.node)
                            ? new roosterjs_editor_dom_1.Position(newPos.node, newPos.isAtEnd ? -3 /* After */ : -2 /* Before */)
                            : newPos;
                    editor
                        .getSelection()
                        .setBaseAndExtent(anchorNode, anchorOffset, newPos.node, newPos.offset);
                }
                else {
                    editor.select(newPos);
                }
            }
        });
    },
};
function cacheGetTableCell(event, editor) {
    return roosterjs_editor_core_1.cacheGetEventData(event, 'TABLECELL_FOR_TABLE_FEATURES', function () {
        var pos = editor.getFocusedPosition();
        var firstTd = pos && editor.getElementAtCursor('TD,TH,LI', pos.node);
        return (firstTd && (roosterjs_editor_dom_1.getTagOfNode(firstTd) == 'LI' ? null : firstTd));
    });
}
//# sourceMappingURL=tableFeatures.js.map